import React, { useEffect, useState } from 'react';
import './SplashAnimation.css';

/**
 * Lightweight 2.5-second CSS-only splash animation.
 * Plays on every new session (sessionStorage), not every route change.
 *
 * Sequence:
 *   0.0s - black screen
 *   0.0-0.5s - sun appears top-left with golden glow, rays radiate
 *   0.5-1.3s - diagonal light beam shoots toward center-bottom
 *   1.3-1.8s - person silhouette glows into existence
 *   1.8-2.5s - fade to app
 */
const SplashAnimation = ({ onComplete }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      try { sessionStorage.setItem('vtd_splash_played', '1'); } catch (_) {}
      setVisible(false);
      if (onComplete) onComplete();
    }, 2500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!visible) return null;

  return (
    <div className="vtd-splash" role="presentation" aria-hidden="true">
      {/* Sun at top-left with golden glow */}
      <div className="vtd-splash__sun">
        <div className="vtd-splash__sun-core" />
        <div className="vtd-splash__sun-glow" />
        {/* Sun rays */}
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="vtd-splash__ray"
            style={{ transform: `rotate(${i * 45}deg)` }}
          />
        ))}
      </div>

      {/* Diagonal light beam */}
      <div className="vtd-splash__beam" />

      {/* Person silhouette */}
      <div className="vtd-splash__person">
        <svg viewBox="0 0 100 200" xmlns="http://www.w3.org/2000/svg">
          {/* Head */}
          <circle cx="50" cy="32" r="18" />
          {/* Neck */}
          <rect x="46" y="48" width="8" height="10" />
          {/* Body/torso */}
          <path d="M 30 60 Q 50 56 70 60 L 68 130 L 32 130 Z" />
          {/* Arms */}
          <path d="M 30 62 Q 22 90 26 130 L 32 130 Z" />
          <path d="M 70 62 Q 78 90 74 130 L 68 130 Z" />
          {/* Legs */}
          <rect x="35" y="128" width="12" height="60" rx="2" />
          <rect x="53" y="128" width="12" height="60" rx="2" />
        </svg>
        <div className="vtd-splash__person-glow" />
      </div>

      {/* VTD text */}
      <div className="vtd-splash__brand">
        <div className="vtd-splash__brand-text">VTD</div>
        <div className="vtd-splash__brand-sub">Astrology</div>
      </div>
    </div>
  );
};

export default SplashAnimation;